import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const pains = ['Quemás perfiles de $15.000/metro por un error de descuento', 'Mandás presupuestos y el cliente desaparece sin respuesta', 'Trabajás 12 horas y al final del mes no te queda ganancia', 'El mercado premium existe pero no tenés la info técnica para entrar'];
export function PainSection() {
  return <section className="py-10 bg-white" data-id="element-130">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-131">
        <div className="text-center mb-6" data-id="element-132">
          <h2 className="text-2xl font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-133">
            ¿Te pasa esto?
          </h2>
          <div className="w-12 h-1 bg-red-600 mx-auto" data-id="element-134"></div>
        </div>

        <div className="space-y-3 mb-8" data-id="element-135">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="flex items-start bg-red-50 border border-red-100 px-5 py-4 shadow-sm" data-id="element-136">
              <XCircle className="w-6 h-6 text-red-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-137" />
              <p className="text-lg font-bold text-matte leading-tight" data-id="element-138">
                {pain}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center bg-matte text-white p-6 border-l-4 border-red-600 shadow-md" data-id="element-139">
          <p className="text-xl md:text-2xl font-black" data-id="element-140">
            Todo eso tiene una sola causa:{' '}
            <span className="text-red-400" data-id="element-141">no tenés el sistema correcto.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}